<template>
  <div :class="['ad-container', {['has-overlay']: requiresLowerCount}, { selected: adIsSelected}]" @click="selectAd">
    <div class="ad-title">
      <h5>{{ad.advertiser_name}}</h5>
    </div>
    <div class="ad-details">
      <div class="branded-image-container">
        <div v-if="requiresLowerCount" class="branded-image__overlay">
          <p class="branded-image__overlay-text">{{targetRecipientText}}</p>
        </div>

        <div class="branded-image">
          <img :src="adAttachmentUrl" class="thumbnail" />
        </div>
      </div>
      <div class="ad-settings">
        <div class="ad-expiration setting">
          <i class="flaticon-calendar"></i>
          <span>expires {{formattedDate}}
            <ad-expiration-warning :sendAtEnd="ad.send_at_end"></ad-expiration-warning>
          </span>
        </div>
        <div v-if="hasTimeRange" class="ad-time-range setting">
          <i class="flaticon-clock"></i>
          <div class="time-range-wrapper">
            <span>{{getTimeRange}}</span>
            <em>send time</em>
          </div>
        </div>
        <div v-if="ad.suggested_text" class="ad-suggested-text setting">
          <i class="flaticon-chat-1"/>

          <popper trigger="hover">
            <div class="popper">
              <div class="title">suggested text</div>
              <span class="content">{{ad.suggested_text}}</span>
            </div>
            <span slot="reference">suggested text</span>
          </popper>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../../../../../node_modules/vue-popperjs/dist/vue-popper.css'
import AdExpirationWarning from './AdExpirationWarning'
import Popper from 'vue-popperjs'
import { format } from 'date-fns'
import { removeTimeZoneAndGetDateUtil } from '../../utilities'
import { mapState } from 'vuex'

  export default {
    props: {
      ad: Object,
      attachedAdId: Number,
      requiresLowerCount: Boolean
    },

    name: 'Ad',

    components: {
      AdExpirationWarning,
      Popper
    },

    computed: {
      adIsSelected() {
        return this.ad?.id === this.attachedAdId
      },

      adAttachmentUrl() {
        return this.ad?.attachments[0].url
      },

      getTimeRange() {
        return this.hasTimeRange ? `${format(removeTimeZoneAndGetDateUtil(this.ad.time_range_start), 'ha')} - ${format(removeTimeZoneAndGetDateUtil(this.ad.time_range_end), 'ha')}` : null
      },

      hasTimeRange() {
        return !!this.ad?.time_range_start && !!this.ad?.time_range_end
      },

      formattedDate() {
        return !!this.ad?.send_at_end ? format(new Date(this.ad?.send_at_end), "MM/dd") : ""
      },

      targetRecipientText() {
        return `target ${this.ad?.credits_left} recipients or less to send this sponsored image`
      },

      ...mapState([
        "currentMerchant"
      ])
    },

    methods: {
      selectAd() {
        if (this.requiresLowerCount) { return }

        this.adIsSelected ? this.$emit('removeAd', !!this.ad.suggested_text) :
          this.$emit('selectedAd', this.ad.id, this.adAttachmentUrl, this.ad.suggested_text, this.ad)
      },
    },
  }
</script>

<style>
  .time-range-wrapper {
    display: flex;
    flex-direction: column;
  }

  .time-range-wrapper p {
    margin-bottom: 0;
  }

  .time-range-wrapper em {
    font-size: small;
    font-style: normal;
    line-height: .8em;
  }

  .setting:not(:last-child) {
    margin-bottom: .6em;
  }

  .ad-suggested-text span {
    line-height: 1.2em;
  }
</style>
